import type { Event } from "~/calendar/CalendarPage";

import { TIME_BLOCKS_TO_EXCLUDE } from "./types";

export default function isEventHasNoAgenda(event: Event): boolean {
	return (
		!event.hasNoteContent &&
		!TIME_BLOCKS_TO_EXCLUDE.includes(event.timeBlockType || "") &&
		!event.isAllDay &&
		!!event.attendeePersonCount &&
		event.attendeePersonCount >= 2 &&
		event.status !== "cancelled"
	);
}
